import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var _priceCoveragePrefixM;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { JoveProjectTypeEnum, QuotePlatformSourceEnum } from '@jove-frontend/enums';
import { getAdminFeeDisplayText, getBrokerCommissionDiscountDisplayText, getBrokerCommissionDisplayText, getBrokerFeeDisplayText, getInsurancePremiumExcludingIPTDisplayText, getInsurancePremiumTaxDisplayText, getQuotePriceIntroductionTextInfo, getTotalPayableDisplayText, getUnderwritingFeeDisplayText, judgeBrokerProductIsEmptyCommission, judgeIsBrokerPromotionQuote, judgeIsPartnerPromotionQuote, judgeLegalEntitySkipSetCommission } from '@jove-frontend/utils';
import { gt, has, isArray, isBoolean, isNumber } from 'lodash';
import { getRecruitmentCoverTypeMap } from '../constants';
import { getTruelyValueMap, truelyValueMap } from '../constants/common';
import { BI_COW_COVER, BUSINESS_INTERUPTION, CMR_COVER, COMPUTER_BREAKDOWN_COVER, DIRECTORS_OFFICERS_COVER, DRIVERS_NEGLIGENCE, DRIVERS_NEGLIGENCE_SWITCH, EMPLOYERS_LIABILITY, EMPLOYMENT_PRACTICES_COVER, EMPLOYMENT_PRACTICES_COVER_SWITCH, EXCESS_LEVEL, FIDELITY_CRIME, FIDELITY_CRIME_SWITCH, GOODS_IN_TRANSIT, LEGAL_EXPENSES_COVER, MONEY_ASSAULT_COVER, PACKAGE_COVER, PORTABLE_EQUIPMENT, PORTABLE_EQUIPMENT_COVER, PROFESSIONAL_INDEMNITY, PROPERTY_COVER, PROPERTY_COVER_TYPE_LIST, PUBLIC_LIABILITY } from '../constants/coverage';
import { greateAmericanCoverList } from '../constants/greateAmerican';
import { PROVIDER_SOURCE } from '../constants/quote';
import { getCoverInfoMapWithExtraConfig, getGreateAmericanCoverMap } from '../localeConstants';
import { getDeductionMethodMap } from '../localeConstants/quote';
import { formatCurrency } from '../shared/formatters';
import { PromotionEntityType } from '../shared/generated';
import { addNumbers, subtractNumbers } from '../utils/decimal';
import { getLocalTranslation } from '../utils/i18nKit';
import { filterSortInsurerCoverageList } from '../utils/quote';
import { transformDateStrToTimeString } from '../utils/time';
import { useTripartiteCooperationText } from './tripartiteCooperation/useTripartiteCooperationText';
export var PRICE_INSURANCE_PREMIUM_KEY = 'insurance-premium';
export var PRICE_INSURANCE_PREMIUM_TAX_KEY = 'insurance-premium-tax';
export var PRICE_ADMIN_FEE_KEY = 'admin-fee';
export var PRICE_PROCESS_FEE_KEY = 'process-fee';
export var PRICE_TOTAL_KEY = 'total';
export var PRICE_BROKER_COMMISSION_KEY = 'broker-commission';
export var PRICE_BROKER_FEE_KEY = 'broker-fee';
export var PRICE_UNDERWRITING_FEE_KEY = 'underwriting-fee';
export var PRICE_BROKER_COMMISSION_DISCOUNT_KEY = 'broker-commission-discount';
export var PRICE_BROKER_DISCOUNT_KEY = 'broker-discount';
export var PRICE_TOTAL_DISCOUNT_KEY = 'total-discount';
export var PRICE_WHOLESALE_BROKER_FEE_KEY = 'wholesale-broker-fee';
export var PRICE_WHOLESALE_BROKER_COMMISSION_KEY = 'wholesale-broker-commission';
export var PRICE_WHOLESALE_BROKER_COMMISSION_DISCOUNT_KEY = 'wholesale-broker-commission-discount';
export var PRICE_OTHER_EXTRA_FEE_COMBINE_UNDER_BROKER_ETC_KEY = 'other-extra-combine-underwritten-broker-fee';
var priceCoveragePrefixMap = (_priceCoveragePrefixM = {}, _defineProperty(_priceCoveragePrefixM, PROFESSIONAL_INDEMNITY, 'pi'), _defineProperty(_priceCoveragePrefixM, PUBLIC_LIABILITY, 'pl'), _defineProperty(_priceCoveragePrefixM, GOODS_IN_TRANSIT, 'git'), _defineProperty(_priceCoveragePrefixM, CMR_COVER, 'cmr'), _defineProperty(_priceCoveragePrefixM, FIDELITY_CRIME, 'fidelity'), _defineProperty(_priceCoveragePrefixM, DRIVERS_NEGLIGENCE, 'driversNeg'), _defineProperty(_priceCoveragePrefixM, EMPLOYERS_LIABILITY, 'el'), _defineProperty(_priceCoveragePrefixM, DIRECTORS_OFFICERS_COVER, 'directorsOfficers'), _defineProperty(_priceCoveragePrefixM, EMPLOYMENT_PRACTICES_COVER, 'employmentPracticesLiability'), _defineProperty(_priceCoveragePrefixM, PROPERTY_COVER_TYPE_LIST, 'property'), _defineProperty(_priceCoveragePrefixM, PACKAGE_COVER, 'packages'), _defineProperty(_priceCoveragePrefixM, EXCESS_LEVEL, 'exl'), _defineProperty(_priceCoveragePrefixM, BI_COW_COVER, 'biIcow'), _priceCoveragePrefixM);
export var useQuotePriceDetailInfo = function useQuotePriceDetailInfo() {
  var _useTripartiteCoopera = useTripartiteCooperationText(),
      updateTripartiteCooperationMultilingualInfo = _useTripartiteCoopera.updateTripartiteCooperationMultilingualInfo;

  var evaluateEmptyText = function evaluateEmptyText(price, text) {
    return price > 0 ? text : 'TBC';
  };
  /** ************************* Great american************************************/


  var generateGreatAmericanPriceSummaryInfoList = function generateGreatAmericanPriceSummaryInfoList(coversPrice, price) {
    var _optionLListRealKeyMa;

    var _getGreateAmericanCov = getGreateAmericanCoverMap(),
        prePowerUnit = _getGreateAmericanCov.prePowerUnit,
        deductible = _getGreateAmericanCov.deductible,
        reloading = _getGreateAmericanCov.reloading,
        debrisRemoval = _getGreateAmericanCov.debrisRemoval,
        earnedFreight = _getGreateAmericanCov.earnedFreight,
        fireDepartment = _getGreateAmericanCov.fireDepartment,
        lossData = _getGreateAmericanCov.lossData,
        rewardCoverage = _getGreateAmericanCov.rewardCoverage,
        pollutantCleanUp = _getGreateAmericanCov.pollutantCleanUp,
        refrigerationBreakdown = _getGreateAmericanCov.refrigerationBreakdown,
        ownersGoodsExtension = _getGreateAmericanCov.ownersGoodsExtension,
        nonOwnedTrailer = _getGreateAmericanCov.nonOwnedTrailer,
        nonOwnedTrailerLimit = _getGreateAmericanCov.nonOwnedTrailerLimit,
        reusablePackingContainers = _getGreateAmericanCov.reusablePackingContainers,
        reusablePackingContainersLimit = _getGreateAmericanCov.reusablePackingContainersLimit,
        tarpsChains = _getGreateAmericanCov.tarpsChains,
        tarpsChainsLimit = _getGreateAmericanCov.tarpsChainsLimit,
        subhaulerOwnerPperator = _getGreateAmericanCov.subhaulerOwnerPperator;

    var list = [];
    var keyList = [prePowerUnit.value, deductible.value, reloading.value, debrisRemoval.value, earnedFreight.value, fireDepartment.value, lossData.value, rewardCoverage.value, pollutantCleanUp.value, refrigerationBreakdown.value, ownersGoodsExtension.value, nonOwnedTrailer.value, reusablePackingContainers.value, tarpsChains.value, subhaulerOwnerPperator.value];
    var optionLListRealKeyMap = (_optionLListRealKeyMa = {}, _defineProperty(_optionLListRealKeyMa, nonOwnedTrailer.value, nonOwnedTrailerLimit.value), _defineProperty(_optionLListRealKeyMa, reusablePackingContainers.value, reusablePackingContainersLimit.value), _defineProperty(_optionLListRealKeyMa, tarpsChains.value, tarpsChainsLimit.value), _optionLListRealKeyMa);

    var _ref = price || {},
        covers_options = _ref.covers_options,
        covers = _ref.covers,
        haveTax = _ref.haveTax;

    keyList.forEach(function (key) {
      var _covers_options, _coversPrice$key;

      var temp = greateAmericanCoverList.find(function (item) {
        return item.value === key;
      });
      var coverageItem = covers_options === null || covers_options === void 0 ? void 0 : (_covers_options = covers_options[optionLListRealKeyMap[key] || key]) === null || _covers_options === void 0 ? void 0 : _covers_options.find(function (item) {
        return item.value === (covers === null || covers === void 0 ? void 0 : covers[optionLListRealKeyMap[key] || key]);
      });

      if (coversPrice !== null && coversPrice !== void 0 && (_coversPrice$key = coversPrice[key]) !== null && _coversPrice$key !== void 0 && _coversPrice$key.price) {
        var _coversPrice$key2, _price$price;

        list.push({
          key: key,
          title: prePowerUnit.value === key ? 'Base Coverages' : temp === null || temp === void 0 ? void 0 : temp.label,
          content: formatCurrency({
            amount: (coversPrice === null || coversPrice === void 0 ? void 0 : (_coversPrice$key2 = coversPrice[key]) === null || _coversPrice$key2 === void 0 ? void 0 : _coversPrice$key2.price) || 0,
            currency: (price === null || price === void 0 ? void 0 : price.currency) || (price === null || price === void 0 ? void 0 : (_price$price = price.price) === null || _price$price === void 0 ? void 0 : _price$price.currency)
          }),
          coverageText: isBooleanContentValueCoverage(key) ? truelyValueMap.yes.label : coverageItem ? coverageItem.label : 'Included'
        });
      }
    });

    if (haveTax) {
      list.push({
        key: 'surcharges',
        title: 'Surcharges',
        content: price === null || price === void 0 ? void 0 : price.taxText,
        coverageText: 'Included'
      });
    }

    return list;
  };

  var generateGreatAmericanPriceSummaryTotalInfoList = function generateGreatAmericanPriceSummaryTotalInfoList(price, config) {
    var _price$priceText, _price$price2, _price$price3, _price$price4, _price$price5, _price$price6, _price$price7, _price$adminFeeText, _price$totalText;

    var list = [{
      key: 'MotorTruckCargo',
      title: 'Motor Truck Cargo',
      content: price === null || price === void 0 ? void 0 : (_price$priceText = price.priceText) === null || _price$priceText === void 0 ? void 0 : _price$priceText.replace('£', '$'),
      original_price: price !== null && price !== void 0 && (_price$price2 = price.price) !== null && _price$price2 !== void 0 && _price$price2.price_before_promotion ? "$".concat(price === null || price === void 0 ? void 0 : (_price$price3 = price.price) === null || _price$price3 === void 0 ? void 0 : _price$price3.price_before_promotion) : '',
      discounted_price: price !== null && price !== void 0 && (_price$price4 = price.price) !== null && _price$price4 !== void 0 && _price$price4.total_promotion_discount ? "$".concat(price === null || price === void 0 ? void 0 : (_price$price5 = price.price) === null || _price$price5 === void 0 ? void 0 : _price$price5.total_promotion_discount) : '',
      discount: price !== null && price !== void 0 && (_price$price6 = price.price) !== null && _price$price6 !== void 0 && _price$price6.promotion ? "$".concat(price === null || price === void 0 ? void 0 : (_price$price7 = price.price) === null || _price$price7 === void 0 ? void 0 : _price$price7.promotion) : ''
    }, {
      key: 'AdminFee',
      title: 'Admin fee',
      content: price === null || price === void 0 ? void 0 : (_price$adminFeeText = price.adminFeeText) === null || _price$adminFeeText === void 0 ? void 0 : _price$adminFeeText.replace('£', '$')
    }];

    if (!!(price !== null && price !== void 0 && price.haveTotalDiscountValue)) {
      var _price$totalDiscountT;

      list.push({
        key: PRICE_TOTAL_DISCOUNT_KEY,
        title: 'Discount',
        content: price === null || price === void 0 ? void 0 : (_price$totalDiscountT = price.totalDiscountText) === null || _price$totalDiscountT === void 0 ? void 0 : _price$totalDiscountT.replace('£', '$')
      });
    }

    list.push({
      key: PRICE_TOTAL_KEY,
      title: 'Total Term Premium',
      content: price === null || price === void 0 ? void 0 : (_price$totalText = price.totalText) === null || _price$totalText === void 0 ? void 0 : _price$totalText.replace('£', '$'),
      textSize: 'big'
    });

    if ((price === null || price === void 0 ? void 0 : price.billing_cycle) === getDeductionMethodMap().monthly.value) {
      var _price$processingFeeT;

      list.splice(2, 0, {
        key: 'ProcessingFee',
        title: 'Processing fee',
        content: price === null || price === void 0 ? void 0 : (_price$processingFeeT = price.processingFeeText) === null || _price$processingFeeT === void 0 ? void 0 : _price$processingFeeT.replace('£', '$')
      });
    }

    return list;
  };

  var generateGreatAmericanMonthlyPaymentScheduleList = function generateGreatAmericanMonthlyPaymentScheduleList(billingSchedule) {
    var list = [];
    (billingSchedule || []).forEach(function (item) {
      list.push({
        key: item.statement_date,
        title: transformDateStrToTimeString(new Date(item.statement_date), {
          format: 'MMM.DD.YYYY'
        }),
        content: item.totalText
      });
    });
    return list;
  };

  var generateGreatAmericanDisplaySelectCoverInfoList = function generateGreatAmericanDisplaySelectCoverInfoList(covers, coverOptions) {
    var tempList = [];

    var _getGreateAmericanCov2 = getGreateAmericanCoverMap(),
        prePowerUnit = _getGreateAmericanCov2.prePowerUnit,
        deductible = _getGreateAmericanCov2.deductible,
        reloading = _getGreateAmericanCov2.reloading,
        debrisRemoval = _getGreateAmericanCov2.debrisRemoval,
        earnedFreight = _getGreateAmericanCov2.earnedFreight,
        fireDepartment = _getGreateAmericanCov2.fireDepartment,
        lossData = _getGreateAmericanCov2.lossData,
        rewardCoverage = _getGreateAmericanCov2.rewardCoverage,
        pollutantCleanUp = _getGreateAmericanCov2.pollutantCleanUp,
        refrigerationBreakdown = _getGreateAmericanCov2.refrigerationBreakdown,
        ownersGoodsExtension = _getGreateAmericanCov2.ownersGoodsExtension,
        nonOwnedTrailer = _getGreateAmericanCov2.nonOwnedTrailer,
        nonOwnedTrailerLimit = _getGreateAmericanCov2.nonOwnedTrailerLimit,
        reusablePackingContainers = _getGreateAmericanCov2.reusablePackingContainers,
        reusablePackingContainersLimit = _getGreateAmericanCov2.reusablePackingContainersLimit,
        tarpsChains = _getGreateAmericanCov2.tarpsChains,
        tarpsChainsLimit = _getGreateAmericanCov2.tarpsChainsLimit;

    var keyList = [prePowerUnit.value, deductible.value, reloading.value, debrisRemoval.value, earnedFreight.value, fireDepartment.value, lossData.value, rewardCoverage.value, pollutantCleanUp.value];
    var coverMapInfoList = Object.values(getGreateAmericanCoverMap());
    keyList.forEach(function (key) {
      if (has(covers, key)) {
        var _coverMapInfoList$fin, _coverOptions$key, _coverOptions$key$fin;

        var selectValue = covers[key];

        if (isBoolean(selectValue)) {
          selectValue = selectValue ? 1 : 0;
        }

        tempList.push({
          title: coverMapInfoList === null || coverMapInfoList === void 0 ? void 0 : (_coverMapInfoList$fin = coverMapInfoList.find(function (item) {
            return item.value === key;
          })) === null || _coverMapInfoList$fin === void 0 ? void 0 : _coverMapInfoList$fin.label,
          content: coverOptions === null || coverOptions === void 0 ? void 0 : (_coverOptions$key = coverOptions[key]) === null || _coverOptions$key === void 0 ? void 0 : (_coverOptions$key$fin = _coverOptions$key.find(function (item) {
            return item.value === selectValue;
          })) === null || _coverOptions$key$fin === void 0 ? void 0 : _coverOptions$key$fin.label
        });
      }
    });
    [refrigerationBreakdown.value, ownersGoodsExtension.value].forEach(function (key) {
      if (covers !== null && covers !== void 0 && covers[key]) {
        var _coverMapInfoList$fin2;

        tempList.push({
          title: coverMapInfoList === null || coverMapInfoList === void 0 ? void 0 : (_coverMapInfoList$fin2 = coverMapInfoList.find(function (item) {
            return item.value === key;
          })) === null || _coverMapInfoList$fin2 === void 0 ? void 0 : _coverMapInfoList$fin2.label,
          content: 'Covered'
        });
      }
    });
    [{
      coverExistKey: nonOwnedTrailer.value,
      displayCoverKey: nonOwnedTrailerLimit.value
    }, {
      coverExistKey: reusablePackingContainers.value,
      displayCoverKey: reusablePackingContainersLimit.value
    }, {
      coverExistKey: tarpsChains.value,
      displayCoverKey: tarpsChainsLimit.value
    }].forEach(function (item) {
      if (covers !== null && covers !== void 0 && covers[item.coverExistKey]) {
        var _coverMapInfoList$fin3, _coverOptions$item$di, _coverOptions$item$di2;

        tempList.push({
          title: coverMapInfoList === null || coverMapInfoList === void 0 ? void 0 : (_coverMapInfoList$fin3 = coverMapInfoList.find(function (aItem) {
            return aItem.value === item.coverExistKey;
          })) === null || _coverMapInfoList$fin3 === void 0 ? void 0 : _coverMapInfoList$fin3.label,
          content: coverOptions === null || coverOptions === void 0 ? void 0 : (_coverOptions$item$di = coverOptions[item.displayCoverKey]) === null || _coverOptions$item$di === void 0 ? void 0 : (_coverOptions$item$di2 = _coverOptions$item$di.find(function (aItem) {
            return aItem.value === covers[item.displayCoverKey];
          })) === null || _coverOptions$item$di2 === void 0 ? void 0 : _coverOptions$item$di2.label
        });
      }
    });
    return tempList;
  };

  var generateAccelerantDisplaySelectCoverInfoList = function generateAccelerantDisplaySelectCoverInfoList(covers, coverOptions, config) {
    var list = [];
    var keyList = [PROFESSIONAL_INDEMNITY];

    if (covers !== null && covers !== void 0 && covers[FIDELITY_CRIME_SWITCH]) {
      keyList.push(FIDELITY_CRIME);
    }

    keyList.push.apply(keyList, [PUBLIC_LIABILITY, EMPLOYERS_LIABILITY, DIRECTORS_OFFICERS_COVER]);

    if (covers !== null && covers !== void 0 && covers[EMPLOYMENT_PRACTICES_COVER_SWITCH]) {
      keyList.push(EMPLOYMENT_PRACTICES_COVER);
    }

    if (!!(covers !== null && covers !== void 0 && covers[LEGAL_EXPENSES_COVER])) {
      keyList.push(LEGAL_EXPENSES_COVER);
    }

    if ((config === null || config === void 0 ? void 0 : config.coverType) === getRecruitmentCoverTypeMap()["package"].value) {
      keyList.push.apply(keyList, [COMPUTER_BREAKDOWN_COVER, MONEY_ASSAULT_COVER]);
    }

    if (!!(covers !== null && covers !== void 0 && covers[PROPERTY_COVER])) {
      keyList.push(PROPERTY_COVER_TYPE_LIST);
    }

    if (!!(covers !== null && covers !== void 0 && covers[PORTABLE_EQUIPMENT_COVER])) {
      keyList.push(PORTABLE_EQUIPMENT_COVER);
    }

    if (!!(covers !== null && covers !== void 0 && covers[BUSINESS_INTERUPTION])) {
      keyList.push(BUSINESS_INTERUPTION);
    }

    generateDisplaySelectCoverInfoList(list, keyList, covers, coverOptions);
    return list;
  };

  var generateRecruitmentDisplaySelectCoverInfoList = function generateRecruitmentDisplaySelectCoverInfoList(covers, coverOptions, config) {
    var list = [];
    var keyList = [PROFESSIONAL_INDEMNITY];

    if (covers !== null && covers !== void 0 && covers[FIDELITY_CRIME_SWITCH]) {
      keyList.push(FIDELITY_CRIME);
    }

    keyList.push.apply(keyList, [PUBLIC_LIABILITY, EMPLOYERS_LIABILITY, DIRECTORS_OFFICERS_COVER]);

    if (covers !== null && covers !== void 0 && covers[DRIVERS_NEGLIGENCE_SWITCH]) {
      keyList.push(DRIVERS_NEGLIGENCE);
    }

    if (covers !== null && covers !== void 0 && covers[EMPLOYMENT_PRACTICES_COVER_SWITCH]) {
      keyList.push(EMPLOYMENT_PRACTICES_COVER);
    }

    if (!!(covers !== null && covers !== void 0 && covers[LEGAL_EXPENSES_COVER])) {
      keyList.push(LEGAL_EXPENSES_COVER);
    }

    if ((config === null || config === void 0 ? void 0 : config.coverType) === getRecruitmentCoverTypeMap()["package"].value) {
      keyList.push.apply(keyList, [COMPUTER_BREAKDOWN_COVER, MONEY_ASSAULT_COVER]);
    }

    if (!!(covers !== null && covers !== void 0 && covers[PROPERTY_COVER])) {
      keyList.push(PROPERTY_COVER_TYPE_LIST);
    }

    if (!!(covers !== null && covers !== void 0 && covers[PORTABLE_EQUIPMENT_COVER])) {
      keyList.push(PORTABLE_EQUIPMENT_COVER);
    }

    if (!!(covers !== null && covers !== void 0 && covers[BUSINESS_INTERUPTION])) {
      keyList.push(BUSINESS_INTERUPTION);
    }

    generateDisplaySelectCoverInfoList(list, keyList, covers, coverOptions);
    return list;
  };

  var generateGitDisplaySelectCoverInfoList = function generateGitDisplaySelectCoverInfoList(covers, coverOptions, config) {
    var list = [];
    var keyList = [GOODS_IN_TRANSIT];

    if (covers !== null && covers !== void 0 && covers[PUBLIC_LIABILITY]) {
      keyList.push(PUBLIC_LIABILITY);
    }

    if (covers !== null && covers !== void 0 && covers[CMR_COVER]) {
      keyList.push(CMR_COVER);
    }

    if (covers !== null && covers !== void 0 && covers[EMPLOYERS_LIABILITY]) {
      keyList.push(EMPLOYERS_LIABILITY);
    }

    generateDisplaySelectCoverInfoList(list, keyList, covers, coverOptions);
    return list;
  };

  var generateGABusinessDisplaySelectCoverInfoList = function generateGABusinessDisplaySelectCoverInfoList(covers, coverOptions, config) {
    var list = [];
    var keyList = [PROFESSIONAL_INDEMNITY];

    if (covers !== null && covers !== void 0 && covers[EXCESS_LEVEL]) {
      keyList.push(EXCESS_LEVEL);
    }

    if (covers !== null && covers !== void 0 && covers[PUBLIC_LIABILITY]) {
      keyList.push(PUBLIC_LIABILITY);
    }

    generateDisplaySelectCoverInfoList(list, keyList, covers, coverOptions, {
      providerCode: PROVIDER_SOURCE().GREATEAMERICAN_BUSINESS_INSURANCE.value
    });
    return list;
  };
  /** ************************* Universal ************************************/


  var isBooleanContentValueCoverage = function isBooleanContentValueCoverage(key) {
    return [PROPERTY_COVER_TYPE_LIST, PORTABLE_EQUIPMENT_COVER, BUSINESS_INTERUPTION, BI_COW_COVER, PORTABLE_EQUIPMENT].includes(key);
  };

  var generateDisplaySelectCoverInfoList = function generateDisplaySelectCoverInfoList(list, keyList, covers, coverOptions, config) {
    keyList.forEach(function (key) {
      if (!!(covers !== null && covers !== void 0 && covers[key])) {
        var _getCoverInfoMapWithE, _coverOptions$key2, _coverOptions$key2$fi;

        list.push({
          title: (_getCoverInfoMapWithE = getCoverInfoMapWithExtraConfig({
            provideCode: config === null || config === void 0 ? void 0 : config.providerCode
          })[key]) === null || _getCoverInfoMapWithE === void 0 ? void 0 : _getCoverInfoMapWithE.label,
          content: isBooleanContentValueCoverage(key) ? getTruelyValueMap().yes.label : coverOptions === null || coverOptions === void 0 ? void 0 : (_coverOptions$key2 = coverOptions[key]) === null || _coverOptions$key2 === void 0 ? void 0 : (_coverOptions$key2$fi = _coverOptions$key2.find(function (item) {
            return item.value === covers[key];
          })) === null || _coverOptions$key2$fi === void 0 ? void 0 : _coverOptions$key2$fi.label
        });
      }
    });
  };

  var generateCommonPriceSummaryInfoList = function generateCommonPriceSummaryInfoList(coversPrice, allPriceInfo, config) {
    var list = [];
    var keyList = Object.keys(coversPrice || {}); // Filter not selected coverage
    // Special: package, bi-icow

    keyList = keyList.filter(function (key) {
      var _allPriceInfo$covers;

      return !!(allPriceInfo !== null && allPriceInfo !== void 0 && (_allPriceInfo$covers = allPriceInfo.covers) !== null && _allPriceInfo$covers !== void 0 && _allPriceInfo$covers[key]) || [PACKAGE_COVER, BI_COW_COVER, PORTABLE_EQUIPMENT, FIDELITY_CRIME].includes(key);
    });
    keyList = filterSortInsurerCoverageList(keyList, {
      providerCode: allPriceInfo === null || allPriceInfo === void 0 ? void 0 : allPriceInfo.provider_code
    });
    keyList.forEach(function (key) {
      var prefixKey = priceCoveragePrefixMap[key];
      var diffValue = (allPriceInfo === null || allPriceInfo === void 0 ? void 0 : allPriceInfo["".concat(prefixKey, "Origin")]) - (allPriceInfo === null || allPriceInfo === void 0 ? void 0 : allPriceInfo[prefixKey]);

      var _ref2 = coversPrice[key] || {},
          price = _ref2.price,
          total = _ref2.total,
          currency = _ref2.currency,
          override_price = _ref2.override_price,
          difference_price = _ref2.difference_price,
          is_referred = _ref2.is_referred,
          coverage = _ref2.coverage;

      if (!!price || !!total || config !== null && config !== void 0 && config.returnReferralCoverage && is_referred) {
        var _allPriceInfo$covers_, _allPriceInfo$covers_2, _getCoverInfoMapWithE2;

        var coverOptionItem = allPriceInfo === null || allPriceInfo === void 0 ? void 0 : (_allPriceInfo$covers_ = allPriceInfo.covers_options) === null || _allPriceInfo$covers_ === void 0 ? void 0 : (_allPriceInfo$covers_2 = _allPriceInfo$covers_[key]) === null || _allPriceInfo$covers_2 === void 0 ? void 0 : _allPriceInfo$covers_2.find(function (cItem) {
          return cItem.value === coverage;
        });
        list.push(_objectSpread(_objectSpread({}, coversPrice[key]), {}, {
          key: key,
          title: (_getCoverInfoMapWithE2 = getCoverInfoMapWithExtraConfig({
            provideCode: allPriceInfo === null || allPriceInfo === void 0 ? void 0 : allPriceInfo.provider_code
          })[key]) === null || _getCoverInfoMapWithE2 === void 0 ? void 0 : _getCoverInfoMapWithE2.label,
          content: formatCurrency({
            amount: price || 0,
            currency: currency
          }),
          overridePriceText: formatCurrency({
            amount: override_price || 0,
            currency: currency
          }),
          differencePriceText: formatCurrency({
            amount: difference_price || 0,
            currency: currency
          }),
          haveDiscount: !!difference_price,
          isAdd: gt(difference_price, 0),
          originPriceText: allPriceInfo === null || allPriceInfo === void 0 ? void 0 : allPriceInfo["".concat(prefixKey, "OriginPriceText")],
          currentPriceText: evaluateEmptyText(allPriceInfo === null || allPriceInfo === void 0 ? void 0 : allPriceInfo[prefixKey], allPriceInfo === null || allPriceInfo === void 0 ? void 0 : allPriceInfo["".concat(prefixKey, "PriceText")]),
          savePercent: diffValue > 0 ? formatCurrency({
            amount: diffValue || 0,
            currency: allPriceInfo === null || allPriceInfo === void 0 ? void 0 : allPriceInfo.currency
          }) : '',
          priceIsSame: (allPriceInfo === null || allPriceInfo === void 0 ? void 0 : allPriceInfo["".concat(prefixKey, "Origin")]) === (allPriceInfo === null || allPriceInfo === void 0 ? void 0 : allPriceInfo[prefixKey]),
          isAnnual: (allPriceInfo === null || allPriceInfo === void 0 ? void 0 : allPriceInfo.billing_cycle) === getDeductionMethodMap().annual.value,
          isReferred: !!is_referred,
          coverageText: isBooleanContentValueCoverage(key) ? truelyValueMap.yes.label : isNumber(coverage) ? !!coverage ? coverOptionItem ? coverOptionItem.label : formatCurrency({
            amount: coverage,
            currency: currency
          }) : 'Included' : coverage
        }));
      }
    });
    return list;
  };

  var appendCoverageItemInfo = function appendCoverageItemInfo(item, priceData) {
    var _covers_options$item$, _coverageTextInfoMap$;

    var provider_code = priceData.provider_code,
        billing_cycle = priceData.billing_cycle,
        aggregate_covers_price = priceData.aggregate_covers_price,
        currency = priceData.currency,
        covers_options = priceData.covers_options;

    var _ref3 = (aggregate_covers_price === null || aggregate_covers_price === void 0 ? void 0 : aggregate_covers_price[item.key]) || {},
        coverage = _ref3.coverage;

    var coverOptionItem = covers_options === null || covers_options === void 0 ? void 0 : (_covers_options$item$ = covers_options[item.key]) === null || _covers_options$item$ === void 0 ? void 0 : _covers_options$item$.find(function (cItem) {
      return cItem.value === coverage;
    });
    var coverageTextInfoMap = getCoverInfoMapWithExtraConfig({
      provideCode: provider_code
    });
    return _objectSpread(_objectSpread({}, item), {}, {
      title: coverageTextInfoMap === null || coverageTextInfoMap === void 0 ? void 0 : (_coverageTextInfoMap$ = coverageTextInfoMap[item.key]) === null || _coverageTextInfoMap$ === void 0 ? void 0 : _coverageTextInfoMap$.label,
      content: item.totalText,
      isAnnual: billing_cycle === getDeductionMethodMap().annual.value,
      coverageText: isBooleanContentValueCoverage(item.key) ? truelyValueMap.yes.label : isNumber(coverage) ? !!coverage ? coverOptionItem ? coverOptionItem.label : formatCurrency({
        amount: coverage,
        currency: currency
      }) : 'Included' : coverage
    });
  };

  var generateCommonCustomCombinePriceSummaryInfoList = function generateCommonCustomCombinePriceSummaryInfoList(price, config) {
    var customCombinedCoverageList = price.customCombinedCoverageList;
    var list = customCombinedCoverageList.map(function (item) {
      var temp = appendCoverageItemInfo(item, price);

      if (isArray(item.subCoverageList)) {
        temp.subCoverageList = item.subCoverageList.map(function (subItem) {
          return appendCoverageItemInfo(subItem, price);
        });
      }

      return temp;
    });
    return list;
  };

  var generateCommonPriceSummaryTotalInfoList = function generateCommonPriceSummaryTotalInfoList(price, config) {
    var _config$userInfo, _config$userInfo2;

    var _getLocalTranslation = getLocalTranslation(),
        $t = _getLocalTranslation.$t;

    var _ref4 = price || {},
        priceText = _ref4.priceText,
        taxText = _ref4.taxText,
        adminFeeText = _ref4.adminFeeText,
        brokerCommisionText = _ref4.brokerCommisionText,
        brokerCommisionPercentageText = _ref4.brokerCommisionPercentageText,
        brokerFeeText = _ref4.brokerFeeText,
        brokerFeePercentageText = _ref4.brokerFeePercentageText,
        brokerDiscountText = _ref4.brokerDiscountText,
        brokerDiscountPercentageText = _ref4.brokerDiscountPercentageText,
        currentPayTotalPremiumText = _ref4.currentPayTotalPremiumText,
        currentPayTaxText = _ref4.currentPayTaxText,
        currentPayAdminFeeText = _ref4.currentPayAdminFeeText,
        currentPayBrokerCommisionText = _ref4.currentPayBrokerCommisionText,
        currentPayBrokerFeeText = _ref4.currentPayBrokerFeeText,
        currentPayBrokerDiscountText = _ref4.currentPayBrokerDiscountText,
        currentPayCombineUnderwritingFeeText = _ref4.currentPayCombineUnderwritingFeeText,
        combineUnderwritingFeeText = _ref4.combineUnderwritingFeeText,
        ready_to_pricing = _ref4.ready_to_pricing,
        priceHaveDiscount = _ref4.priceHaveDiscount,
        originalPriceText = _ref4.originalPriceText,
        totalDiscountText = _ref4.totalDiscountText,
        combineBrokerFeeText = _ref4.combineBrokerFeeText,
        currentPayCombineBrokerFeeText = _ref4.currentPayCombineBrokerFeeText,
        wholeSaleBrokerFeeText = _ref4.wholeSaleBrokerFeeText,
        currentPayWholeSaleBrokerFeeText = _ref4.currentPayWholeSaleBrokerFeeText,
        wholeSaleBrokerFeePercentageText = _ref4.wholeSaleBrokerFeePercentageText,
        currentPayWholeSaleBrokerCommisionText = _ref4.currentPayWholeSaleBrokerCommisionText,
        wholeSaleBrokerCommisionText = _ref4.wholeSaleBrokerCommisionText,
        wholeSaleBrokerCommisionPercentageText = _ref4.wholeSaleBrokerCommisionPercentageText,
        currentPayWholeSaleBrokerDiscountText = _ref4.currentPayWholeSaleBrokerDiscountText,
        wholeSaleBrokerDiscountText = _ref4.wholeSaleBrokerDiscountText,
        wholeSaleBrokerDiscountPercentageText = _ref4.wholeSaleBrokerDiscountPercentageText,
        haveWholeSaleBrokerCommissionValue = _ref4.haveWholeSaleBrokerCommissionValue,
        haveWholeSaleBrokerDiscountValue = _ref4.haveWholeSaleBrokerDiscountValue,
        haveWholeSaleBrokerFeeValue = _ref4.haveWholeSaleBrokerFeeValue,
        haveTotalDiscountValue = _ref4.haveTotalDiscountValue,
        haveCustomDiscountValue = _ref4.haveCustomDiscountValue,
        customDiscountText = _ref4.customDiscountText,
        haveBrokerCommissionValue = _ref4.haveBrokerCommissionValue,
        haveTax = _ref4.haveTax,
        haveBrokerDiscountValue = _ref4.haveBrokerDiscountValue,
        haveBrokerFeeValue = _ref4.haveBrokerFeeValue,
        haveCombineBrokerFeeValue = _ref4.haveCombineBrokerFeeValue;

    var _ref5 = config || {},
        displayCurrentPaymentPriceInfo = _ref5.displayCurrentPaymentPriceInfo,
        promotionType = _ref5.promotionType,
        filterOutDisplayList = _ref5.filterOutDisplayList,
        country = _ref5.country,
        promotionInfo = _ref5.promotionInfo,
        platformSourceType = _ref5.platformSourceType;

    var currentPromotionType = (promotionInfo === null || promotionInfo === void 0 ? void 0 : promotionInfo.promotionType) || promotionType;
    var isMasterPromotionQuote = !(promotionInfo !== null && promotionInfo !== void 0 && promotionInfo.promotionParentId);
    var isWholeSaleBrokerVisit = (config === null || config === void 0 ? void 0 : (_config$userInfo = config.userInfo) === null || _config$userInfo === void 0 ? void 0 : _config$userInfo.isParentBroker) || platformSourceType !== QuotePlatformSourceEnum.portal && (config === null || config === void 0 ? void 0 : (_config$userInfo2 = config.userInfo) === null || _config$userInfo2 === void 0 ? void 0 : _config$userInfo2.isJoveAdmin);
    var isPartnerQuote = judgeIsPartnerPromotionQuote(promotionInfo);
    var isPromotionQuote = [PromotionEntityType.BROKER_PROMOTION, PromotionEntityType.PARTNER_PROMOTION].includes(currentPromotionType);
    var underwrittingFeeTitle = judgeIsBrokerPromotionQuote(promotionInfo) ? getUnderwritingFeeDisplayText(country, {
      initialText: $t('kit:quotes.underwritting_fee')
    }) : getAdminFeeDisplayText(country, {
      initialText: $t('kit:quotes.admin_fee')
    });
    var isCMSProject = [JoveProjectTypeEnum.cms].includes(config === null || config === void 0 ? void 0 : config.projectSource);
    var skipSetCommission = judgeLegalEntitySkipSetCommission(promotionInfo);
    var isSetEmptyCommission = judgeBrokerProductIsEmptyCommission(promotionInfo);
    var emptyPriceCommonText = '-';
    var list = []; // Premium price

    if (![PROVIDER_SOURCE().HISCOX_US.value].includes(price === null || price === void 0 ? void 0 : price.provider_code)) {
      list.push({
        title: getInsurancePremiumExcludingIPTDisplayText(country, {
          initialText: $t('kit:quotes.insurance_premium_excluding_IPT')
        }),
        content: ready_to_pricing ? displayCurrentPaymentPriceInfo ? currentPayTotalPremiumText : priceText : emptyPriceCommonText,
        key: PRICE_INSURANCE_PREMIUM_KEY,
        hasDiscount: priceHaveDiscount,
        originalPrice: originalPriceText
      });
    } // Tax


    if (![PROVIDER_SOURCE().HISCOX_US.value].includes(price === null || price === void 0 ? void 0 : price.provider_code) && haveTax) {
      list.push({
        title: getInsurancePremiumTaxDisplayText(country, {
          initialText: $t('kit:quotes.insurance_premium_tax')
        }),
        content: ready_to_pricing ? displayCurrentPaymentPriceInfo ? currentPayTaxText : taxText : emptyPriceCommonText,
        key: PRICE_INSURANCE_PREMIUM_TAX_KEY
      });
    } // Admin fee


    if (![PROVIDER_SOURCE().HISCOX_US.value].includes(price === null || price === void 0 ? void 0 : price.provider_code)) {
      list.push({
        title: getAdminFeeDisplayText(country, {
          initialText: $t('kit:quotes.admin_fee')
        }),
        content: ready_to_pricing ? displayCurrentPaymentPriceInfo ? currentPayAdminFeeText : adminFeeText : emptyPriceCommonText,
        key: PRICE_ADMIN_FEE_KEY
      });
    } // Broker commission


    if (isCMSProject && isPromotionQuote) {
      var showWholeSaleBrokerCommission = isWholeSaleBrokerVisit && !isMasterPromotionQuote && haveWholeSaleBrokerCommissionValue;

      if (!(filterOutDisplayList !== null && filterOutDisplayList !== void 0 && filterOutDisplayList.includes(PRICE_WHOLESALE_BROKER_COMMISSION_KEY)) && showWholeSaleBrokerCommission) {
        list.push({
          title: getBrokerCommissionDisplayText(country, {
            isWholeSaleBrokerVisit: isWholeSaleBrokerVisit,
            isMasterPromotionQuote: isMasterPromotionQuote,
            isPartnerQuote: isPartnerQuote,
            priceKey: PRICE_WHOLESALE_BROKER_COMMISSION_KEY,
            haveWholeSaleBrokerCommissionValue: haveWholeSaleBrokerCommissionValue
          }),
          content: ready_to_pricing ? displayCurrentPaymentPriceInfo ? currentPayWholeSaleBrokerCommisionText : "".concat(wholeSaleBrokerCommisionText) + (!!wholeSaleBrokerCommisionPercentageText ? " (".concat(wholeSaleBrokerCommisionPercentageText, ")") : '') : emptyPriceCommonText,
          key: PRICE_WHOLESALE_BROKER_COMMISSION_KEY,
          introductionText: getQuotePriceIntroductionTextInfo({
            isPartnerQuote: isPartnerQuote,
            priceKey: PRICE_WHOLESALE_BROKER_COMMISSION_KEY
          }),
          havePrice: haveWholeSaleBrokerCommissionValue
        });
      }

      if (!isSetEmptyCommission && !(filterOutDisplayList !== null && filterOutDisplayList !== void 0 && filterOutDisplayList.includes(PRICE_BROKER_COMMISSION_KEY)) && haveBrokerCommissionValue) {
        list.push({
          title: getBrokerCommissionDisplayText(country, {
            isWholeSaleBrokerVisit: isWholeSaleBrokerVisit,
            isMasterPromotionQuote: isMasterPromotionQuote,
            isPartnerQuote: isPartnerQuote,
            priceKey: PRICE_BROKER_COMMISSION_KEY,
            haveWholeSaleBrokerCommissionValue: haveWholeSaleBrokerCommissionValue
          }),
          content: ready_to_pricing ? displayCurrentPaymentPriceInfo ? currentPayBrokerCommisionText : "".concat(brokerCommisionText) + (!!brokerCommisionPercentageText ? " (".concat(brokerCommisionPercentageText, ")") : '') : emptyPriceCommonText,
          key: PRICE_BROKER_COMMISSION_KEY,
          introductionText: getQuotePriceIntroductionTextInfo({
            isPartnerQuote: isPartnerQuote,
            priceKey: isMasterPromotionQuote ? PRICE_WHOLESALE_BROKER_COMMISSION_KEY : PRICE_BROKER_COMMISSION_KEY
          }),
          havePrice: haveBrokerCommissionValue
        });
      }
    } // Broker commission discount


    if (isCMSProject && isPromotionQuote) {
      var showWholeSaleBrokerDiscount = isWholeSaleBrokerVisit && !isMasterPromotionQuote && haveWholeSaleBrokerDiscountValue;

      if (!(filterOutDisplayList !== null && filterOutDisplayList !== void 0 && filterOutDisplayList.includes(PRICE_WHOLESALE_BROKER_COMMISSION_DISCOUNT_KEY)) && showWholeSaleBrokerDiscount) {
        list.push({
          title: getBrokerCommissionDiscountDisplayText(country, {
            isWholeSaleBrokerVisit: isWholeSaleBrokerVisit,
            isMasterPromotionQuote: isMasterPromotionQuote,
            isPartnerQuote: isPartnerQuote,
            priceKey: PRICE_WHOLESALE_BROKER_COMMISSION_DISCOUNT_KEY
          }),
          content: ready_to_pricing ? displayCurrentPaymentPriceInfo ? "-".concat(currentPayWholeSaleBrokerDiscountText) : "-".concat(wholeSaleBrokerDiscountText) + (!!wholeSaleBrokerDiscountPercentageText ? " (".concat(wholeSaleBrokerDiscountPercentageText, ")") : '') : emptyPriceCommonText,
          key: PRICE_WHOLESALE_BROKER_COMMISSION_DISCOUNT_KEY,
          introductionText: getQuotePriceIntroductionTextInfo({
            isPartnerQuote: isPartnerQuote,
            priceKey: PRICE_WHOLESALE_BROKER_COMMISSION_DISCOUNT_KEY
          }),
          havePrice: haveWholeSaleBrokerDiscountValue
        });
      }

      if (!isSetEmptyCommission && !(filterOutDisplayList !== null && filterOutDisplayList !== void 0 && filterOutDisplayList.includes(PRICE_BROKER_COMMISSION_DISCOUNT_KEY))) {
        list.push({
          title: getBrokerCommissionDiscountDisplayText(country, {
            isWholeSaleBrokerVisit: isWholeSaleBrokerVisit,
            isMasterPromotionQuote: isMasterPromotionQuote,
            isPartnerQuote: isPartnerQuote,
            priceKey: PRICE_BROKER_COMMISSION_DISCOUNT_KEY
          }),
          content: ready_to_pricing ? displayCurrentPaymentPriceInfo ? "-".concat(currentPayBrokerDiscountText) : "-".concat(brokerDiscountText) + (!!brokerDiscountPercentageText ? " (".concat(brokerDiscountPercentageText, ")") : '') : emptyPriceCommonText,
          key: PRICE_BROKER_COMMISSION_DISCOUNT_KEY,
          introductionText: getQuotePriceIntroductionTextInfo({
            isPartnerQuote: isPartnerQuote,
            priceKey: isMasterPromotionQuote ? PRICE_WHOLESALE_BROKER_COMMISSION_DISCOUNT_KEY : PRICE_BROKER_COMMISSION_DISCOUNT_KEY
          }),
          havePrice: haveBrokerDiscountValue
        });
      }
    } // Broker fee


    if (isPromotionQuote) {
      if (isCMSProject) {
        var showWholeSaleBrokerFee = isWholeSaleBrokerVisit && !isMasterPromotionQuote || !isWholeSaleBrokerVisit && !isMasterPromotionQuote && haveWholeSaleBrokerFeeValue;

        if (!(filterOutDisplayList !== null && filterOutDisplayList !== void 0 && filterOutDisplayList.includes(PRICE_WHOLESALE_BROKER_FEE_KEY)) && showWholeSaleBrokerFee) {
          list.push({
            title: getBrokerFeeDisplayText(country, {
              isWholeSaleBrokerVisit: isWholeSaleBrokerVisit,
              isMasterPromotionQuote: isMasterPromotionQuote,
              isPartnerQuote: isPartnerQuote,
              priceKey: PRICE_WHOLESALE_BROKER_FEE_KEY,
              projectSource: config === null || config === void 0 ? void 0 : config.projectSource
            }),
            content: ready_to_pricing ? displayCurrentPaymentPriceInfo ? currentPayWholeSaleBrokerFeeText : "".concat(wholeSaleBrokerFeeText) + (!!wholeSaleBrokerFeePercentageText ? " (".concat(wholeSaleBrokerFeePercentageText, ")") : '') : emptyPriceCommonText,
            key: PRICE_WHOLESALE_BROKER_FEE_KEY,
            introductionText: getQuotePriceIntroductionTextInfo({
              isPartnerQuote: isPartnerQuote,
              priceKey: PRICE_WHOLESALE_BROKER_FEE_KEY
            }),
            havePrice: haveWholeSaleBrokerFeeValue
          });
        }

        if (!(!!skipSetCommission && isPartnerQuote) && !(filterOutDisplayList !== null && filterOutDisplayList !== void 0 && filterOutDisplayList.includes(PRICE_BROKER_FEE_KEY))) {
          list.push({
            title: getBrokerFeeDisplayText(country, {
              isWholeSaleBrokerVisit: isWholeSaleBrokerVisit,
              isMasterPromotionQuote: isMasterPromotionQuote,
              isPartnerQuote: isPartnerQuote,
              priceKey: PRICE_BROKER_FEE_KEY,
              projectSource: config === null || config === void 0 ? void 0 : config.projectSource
            }),
            content: ready_to_pricing ? displayCurrentPaymentPriceInfo ? currentPayBrokerFeeText : "".concat(brokerFeeText) + (!!brokerFeePercentageText ? " (".concat(brokerFeePercentageText, ")") : '') : emptyPriceCommonText,
            key: PRICE_BROKER_FEE_KEY,
            introductionText: getQuotePriceIntroductionTextInfo({
              isPartnerQuote: isPartnerQuote,
              priceKey: isMasterPromotionQuote ? PRICE_WHOLESALE_BROKER_FEE_KEY : PRICE_BROKER_FEE_KEY
            }),
            havePrice: haveBrokerFeeValue
          });
        }
      } else {
        if (!(filterOutDisplayList !== null && filterOutDisplayList !== void 0 && filterOutDisplayList.includes(PRICE_BROKER_FEE_KEY))) {
          list.push({
            title: getBrokerFeeDisplayText(country, {
              isWholeSaleBrokerVisit: isWholeSaleBrokerVisit,
              isMasterPromotionQuote: isMasterPromotionQuote,
              isPartnerQuote: isPartnerQuote,
              priceKey: PRICE_BROKER_FEE_KEY,
              projectSource: config === null || config === void 0 ? void 0 : config.projectSource
            }),
            content: ready_to_pricing ? displayCurrentPaymentPriceInfo ? currentPayCombineBrokerFeeText : combineBrokerFeeText : emptyPriceCommonText,
            key: PRICE_BROKER_FEE_KEY,
            introductionText: getQuotePriceIntroductionTextInfo({
              isPartnerQuote: isPartnerQuote,
              priceKey: PRICE_BROKER_FEE_KEY
            }),
            havePrice: haveCombineBrokerFeeValue
          });
        }
      }
    } // Underwriting fee


    if (isPromotionQuote) {
      list = list.filter(function (item) {
        return ![PRICE_UNDERWRITING_FEE_KEY, PRICE_ADMIN_FEE_KEY].includes(item.key);
      });
      list.push({
        title: underwrittingFeeTitle,
        content: ready_to_pricing ? displayCurrentPaymentPriceInfo ? currentPayCombineUnderwritingFeeText : "".concat(combineUnderwritingFeeText) : emptyPriceCommonText,
        key: PRICE_UNDERWRITING_FEE_KEY,
        introductionText: getQuotePriceIntroductionTextInfo({
          isPartnerQuote: isPartnerQuote,
          priceKey: PRICE_UNDERWRITING_FEE_KEY
        })
      });
    } // Discount


    if ([JoveProjectTypeEnum.cms].includes(config === null || config === void 0 ? void 0 : config.projectSource)) {
      if (haveCustomDiscountValue) {
        list.push({
          title: $t('kit:quotes.discount'),
          content: ready_to_pricing ? customDiscountText : emptyPriceCommonText,
          key: PRICE_TOTAL_DISCOUNT_KEY
        });
      }
    } else {
      if (haveTotalDiscountValue) {
        list.push({
          title: $t('kit:quotes.discount'),
          content: ready_to_pricing ? totalDiscountText : emptyPriceCommonText,
          key: PRICE_TOTAL_DISCOUNT_KEY
        });
      }
    } // Total price


    if (!(filterOutDisplayList !== null && filterOutDisplayList !== void 0 && filterOutDisplayList.includes(PRICE_TOTAL_KEY))) {
      list.push({
        title: getTotalPayableDisplayText(country, {
          initialText: $t('kit:quotes.total_payable')
        }),
        content: ready_to_pricing ? price === null || price === void 0 ? void 0 : price.totalText : emptyPriceCommonText,
        key: PRICE_TOTAL_KEY,
        textSize: 'big'
      });
    }

    return list;
  };
  /** ************************* External methods ************************************/


  var generateQuotePriceSummaryInfoList = function generateQuotePriceSummaryInfoList(price, config) {
    var list = [];

    var _ref6 = price || {},
        provider_code = _ref6.provider_code;

    if (provider_code === PROVIDER_SOURCE().GREATEAMERICAN.value) {
      list = generateGreatAmericanPriceSummaryInfoList(price === null || price === void 0 ? void 0 : price[(config === null || config === void 0 ? void 0 : config.coveragePriceDataKey) || 'covers_price'], price);
    } else if ([PROVIDER_SOURCE().HISCOX_US.value].includes(provider_code)) {
      list = generateCommonCustomCombinePriceSummaryInfoList(price, config);
    } else {
      list = generateCommonPriceSummaryInfoList(price === null || price === void 0 ? void 0 : price[(config === null || config === void 0 ? void 0 : config.coveragePriceDataKey) || 'aggregate_covers_price'], price, config);
    }

    return list;
  };

  var generateQuotePriceSummaryTotalInfoList = function generateQuotePriceSummaryTotalInfoList(price, config) {
    var list = [];

    if ((price === null || price === void 0 ? void 0 : price.provider_code) === PROVIDER_SOURCE().GREATEAMERICAN.value) {
      list = generateGreatAmericanPriceSummaryTotalInfoList(price, config);
    } else {
      list = generateCommonPriceSummaryTotalInfoList(price, config);
    }

    return list;
  };

  var generateQuotePricePaymentScheduleList = function generateQuotePricePaymentScheduleList(priceInfo) {
    var list = [];
    ((priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.billingSchedule) || []).forEach(function (item) {
      list.push(_objectSpread(_objectSpread({}, item), {}, {
        key: item.statement_date,
        title: transformDateStrToTimeString(new Date(item.statement_date), {
          format: 'MMM.DD.YYYY'
        }),
        content: item.totalText
      }));
    });
    return list;
  };

  var generateUniversalDisplaySelectCoverInfoList = function generateUniversalDisplaySelectCoverInfoList(covers, coverOptions, config) {
    var list = [];

    switch (config === null || config === void 0 ? void 0 : config.providerCode) {
      case PROVIDER_SOURCE().GREATEAMERICAN.value:
        list = generateGreatAmericanDisplaySelectCoverInfoList(covers, coverOptions);
        break;

      case PROVIDER_SOURCE().ACCELERANT.value:
        list = generateAccelerantDisplaySelectCoverInfoList(covers, coverOptions, config);
        break;

      case PROVIDER_SOURCE().RECRUITMENT.value:
        list = generateRecruitmentDisplaySelectCoverInfoList(covers, coverOptions, config);
        break;

      case PROVIDER_SOURCE().ACCELERANT_GIT.value:
        list = generateGitDisplaySelectCoverInfoList(covers, coverOptions, config);
        break;

      case PROVIDER_SOURCE().GREATEAMERICAN_BUSINESS_INSURANCE.value:
        list = generateGABusinessDisplaySelectCoverInfoList(covers, coverOptions, config);
        break;

      default:
        break;
    }

    return list;
  };

  var generateQuotePriceCurrentPayInfo = function generateQuotePriceCurrentPayInfo(price) {
    var _ref7 = price || {},
        billing_cycle = _ref7.billing_cycle,
        totalText = _ref7.totalText,
        billing_schedule = _ref7.billing_schedule,
        currentPayPrice = _ref7.currentPayPrice,
        currentPaySubtotal = _ref7.currentPaySubtotal;

    var nextPayPrice = '';

    if ((billing_schedule === null || billing_schedule === void 0 ? void 0 : billing_schedule.length) > 1) {
      for (var i = 1; i < billing_schedule.length; i++) {
        var _item$price;

        var item = billing_schedule[i];

        if (!nextPayPrice && !!Number((_item$price = item.price) === null || _item$price === void 0 ? void 0 : _item$price.total)) {
          nextPayPrice = item.totalText;
        }
      }
    }

    return {
      billingCycle: billing_cycle,
      annualCurrentPayText: totalText,
      monthlySchedulePayText: nextPayPrice,
      monthlyCurrentPayText: currentPayPrice,
      currentPayText: currentPayPrice,
      currentPayPremiumText: currentPaySubtotal
    };
  };

  var generateQuotePriceSummaryTotalExtraInfoList = function generateQuotePriceSummaryTotalExtraInfoList(price, config) {
    var _ref8 = price || {},
        combineUnderwritingFeeAmount = _ref8.combineUnderwritingFeeAmount,
        wholeSaleBrokerFeeAmount = _ref8.wholeSaleBrokerFeeAmount,
        wholeSaleBrokerDiscountAmount = _ref8.wholeSaleBrokerDiscountAmount,
        currency = _ref8.currency;

    var _ref9 = config || {},
        promotionInfo = _ref9.promotionInfo;

    var isMasterPromotionQuote = !(promotionInfo !== null && promotionInfo !== void 0 && promotionInfo.promotionParentId);
    var isCMSProject = [JoveProjectTypeEnum.cms].includes(config === null || config === void 0 ? void 0 : config.projectSource);
    var list = []; // Other fees

    if (isCMSProject && !isMasterPromotionQuote) {
      list.push({
        title: 'Other fees',
        content: formatCurrency({
          amount: subtractNumbers(addNumbers(combineUnderwritingFeeAmount, wholeSaleBrokerFeeAmount), wholeSaleBrokerDiscountAmount),
          currency: currency
        }),
        key: PRICE_OTHER_EXTRA_FEE_COMBINE_UNDER_BROKER_ETC_KEY
      });
    }

    return list;
  };

  return {
    generateQuotePriceSummaryInfoList: generateQuotePriceSummaryInfoList,
    generateQuotePriceSummaryTotalInfoList: generateQuotePriceSummaryTotalInfoList,
    generateQuotePricePaymentScheduleList: generateQuotePricePaymentScheduleList,
    generateGreatAmericanPriceSummaryInfoList: generateGreatAmericanPriceSummaryInfoList,
    generateGreatAmericanPriceSummaryTotalInfoList: generateGreatAmericanPriceSummaryTotalInfoList,
    generateGreatAmericanMonthlyPaymentScheduleList: generateGreatAmericanMonthlyPaymentScheduleList,
    generateUniversalDisplaySelectCoverInfoList: generateUniversalDisplaySelectCoverInfoList,
    generateQuotePriceCurrentPayInfo: generateQuotePriceCurrentPayInfo,
    generateQuotePriceSummaryTotalExtraInfoList: generateQuotePriceSummaryTotalExtraInfoList
  };
};